import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Thu Aug 29 2018
 * @author LZe
 */
import * as React from 'react';

var Filter =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Filter, _React$PureComponent);

  function Filter() {
    var _this;

    _classCallCheck(this, Filter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Filter).apply(this, arguments));
    /**
     * Sets hidePopup method
     */

    _this.afterGuiAttached = function (params) {
      _this.hidePopup = params.hidePopup;
    };

    _this.onApply = function () {
      _this.closePopup();
    };

    return _this;
  }
  /**
   * Closes the popup
   */


  _createClass(Filter, [{
    key: "closePopup",
    value: function closePopup() {
      this.props.filterChangedCallback(); // Commented to be unified with the default AgGrid filters
      // this.hidePopup();
    }
  }]);

  return Filter;
}(React.PureComponent);

export { Filter as default };